import React from "react";
import { View } from "react-native";
import { Text } from "../Text/Text";
import { styles } from "./Pill.styles";
export const Pill = ({ color = "brand", styles: userStyles, size = "medium", children, ...rest }) => {
    return (React.createElement(View, { testID: "pillComponent", style: [styles.defaults, styles[color], styles[size], userStyles], ...rest },
        React.createElement(Text, { styles: [styles.text, styles[size], styles[color]] }, children)));
};
//# sourceMappingURL=Pill.js.map